export const pafAEVFields = {
    pafId: {
        name: "paf_id",
        label: "PAF Id",
        required: false,
    },
    pafSid: {
        name: "paf_sid",
        label: "Company SID",
        required: false,
    },
    isForeignLocation: {
        name: "is_foreign_location",
        label: "Foreign Location",
        required: true,
    },
    isNcoa: {
        name: "is_ncoa",
        label: "NCOALink Service",
        required: true,
    },
    isDsf: {
        name: "is_dsf",
        label: "DSF2 Service",
        required: true,
    },
    isTriplex: {
        name: "is_triplex",
        label: "Triplex",
        required: true,
    },
    isWaiverOnFile: {
        name: "is_waiver_on_file",
        label: "NCOALink 7-Day Fulfillment Waiver on File",
        required: true,
    },
    listName: {
        name: "list_name",
        label: "List Name",
        required: false,
    },
    comments: {
        name: "comments",
        label: "Comments",
        required: false,
    },
    notes: {
        name: "notes",
        label: "Notes",
        required: false,
    },
    customerSignedDatetime: {
        name: "list_owner_signature_date",
        label: "Customer Signed Date",
        required: false,
    },
    brokerSignedDatetime: {
        name: "list_admin_signature_date",
        label: "List Admin Signed Date",
        required: false,
    },
    licenseeSignedDatetime: {
        name: "licensee_signature_date",
        label: "Licensee Signed Date",
        required: false,
    },
    frequency: {
        name: "frequency",
        label: "Frequency",
        required: false,
    },
    status: {
        name: "status",
        label: "Status",
        required: false,
    },
    signatureStatus: {
        name: "signature_status",
        label: "signature_status",
        required: false,
    },
    isDeleted: {
        name: "is_deleted",
        label: "Is Deleted",
        required: true,
    },
    expirationDate: {
        name: "expiration_date",
        label: "Expiration Date",
        required: false,
    },
    createDatetime: {
        name: "create_datetime",
        label: "Created at",
        required: false,
    },
    modifyDatetime: {
        name: "modify_datetime",
        label: "Modified at",
        required: false,
    },
    modifyUserId: {
        name: "modify_user_id",
        label: "Modified By Id",
        required: false,
    },
    modifyUserName: {
        name: "modify_user_name",
        label: "Modified By",
        required: false,
    },
    customerId: {
        name: "customer_id",
        label: "Customer Id",
        required: true,
    },
    companyName: {
        name: "company__company_name",
        label: "Company Name",
        required: true,
    },
    parentCompanyName: {
        name: "company__parent_company_name",
        label: "Parent Company Name",
        required: false,
    },
    dbaName: {
        name: "company__dba_name",
        label: "DBA Name",
        required: false,
    },
    address1: {
        name: "company__address1",
        label: "Address 1",
        required: true,
    },
    address2: {
        name: "company__address2",
        label: "Address 2",
        required: false,
    },
    city: {
        name: "company__city",
        label: "City",
        required: true,
    },
    state: {
        name: "company__state",
        label: "State",
        required: true,
    },
    postalCode: {
        name: "company__postal_code",
        label: "Zip",
        required: true,
    },
    urbanization: {
        name: "company__urbanization",
        label: "Urbanization",
        required: false,
    },
    federalTaxId: {
        name: "company__federal_tax_id",
        label: "Federal Tax Id",
        required: false,
    },
    naicsCode: {
        name: "company__naics_code",
        label: "NAICS Code",
        required: true,
    },
    uspsMailerId: {
        name: "company__usps_mailer_id",
        label: "USPS Mailer Id",
        required: false,
    },
    customerRegistrationId: {
        name: "company__company_registration_id",
        label: "CR ID",
        required: false,
    },
    representativeName: {
        name: "company__representative_name",
        label: "Representative Name",
        required: true,
    },
    representativeTitle: {
        name: "company__representative_title",
        label: "Representative Title",
        required: false,
    },
    representativeEmail: {
        name: "company__representative_email",
        label: "Representative Email",
        required: true,
    },
    companyWebsite: {
        name: "company__company_website",
        label: "Company Website",
        required: false,
    },
    phone: {
        name: "company__phone",
        label: "Telephone",
        required: true,
    },
    customerSinceDate: {
        name: "company__customer_since_date",
        label: "Customer Since Date",
        required: true,
    },
    customerIsDeleted: {
        name: "company__is_deleted",
        label: "Is Deleted",
        required: true,
    },
    customerIsInternal: {
        name: "company__is_internal",
        label: "Is Internal",
        required: true,
    },
    listAdminId: {
        name: "listadmin_id",
        label: "Broker Id",
        required: false,
    },
    listAdminSid: {
        name: "listadmin__listadmin_sid",
        label: "Broker SID",
        required: false,
    },
    listAdminCompanyName: {
        name: "listadmin__company_name",
        label: "Company Name",
        required: false,
    },
    listAdminAddress1: {
        name: "listadmin__address1",
        label: "Address 1",
        required: false,
    },
    listAdminAddress2: {
        name: "listadmin__address2",
        label: "Address 2",
        required: false,
    },
    listAdminCity: {
        name: "listadmin__city",
        label: "City",
        required: false,
    },
    listAdminState: {
        name: "listadmin__state",
        label: "State",
        required: false,
    },
    listAdminPostalCode: {
        name: "listadmin__postal_code",
        label: "Zip",
        required: false,
    },
    listAdminRepresentativeName: {
        name: "listadmin__representative_name",
        label: "Representative Name",
        required: false,
    },
    listAdminRepresentativeTitle: {
        name: "listadmin__representative_title",
        label: "Representative Title",
        required: false,
    },
    listAdminRepresentativeEmail: {
        name: "listadmin__representative_email",
        label: "Representative Email",
        required: false,
    },
    listAdminPhone: {
        name: "listadmin__phone",
        label: "Phone",
        required: false,
    },
    listAdminFederalTaxId: {
        name: "listadmin__federal_tax_id",
        label: "Fedreal Tax Id",
        required: false,
    },
    listAdminNaicsCode: {
        name: "listadmin__naics_code",
        label: "NAICS",
        required: false,
    },
    licenseeId: {
        name: "licensee_id",
        label: "Licensee Id",
        required: false,
    },
    licenseeAcctExec: {
        name: "licensee_acct_exec",
        label: "Account Exec",
        required: true,
    },
    licenseeSalesOffice: {
        name: "licensee_sales_office",
        label: "Sales Office",
        required: false,
    },
    licenseeOperator: {
        name: "licensee_operator",
        label: "Operator",
        required: true,
    },
    licenseeCompanyName: {
        name: "licensee__company_name",
        label: "Company Name",
        required: false,
    },
    licenseeOfficerName: {
        name: "licensee__officer_name",
        label: "Officer Name",
        required: false,
    },
    licenseeOfficerTitle: {
        name: "licensee__officer_title",
        label: "Officer Title",
        required: false,
    },
    licenseePhone: {
        name: "licensee__phone",
        label: "Phone",
        required: false,
    },
    licenseeFax: {
        name: "licensee__fax",
        label: "Fax",
        required: false,
    },
    licenseeFederalTaxId: {
        name: "licensee__federal_tax_id",
        label: "Federal Tax Id",
        required: false,
    },
    licenseeSignatureAttest: {
        name: "licensee_signature_attest",
        label: "",
        required: false,
    },
    licenseeSignatureText: {
        name: "licensee_signature_text",
        label: "Licensee Signature",
        required: false,
    },
    licenseeSignatureDate: {
        name: "licensee_signature_date",
        label: "Licensee Signed Date",
        required: false,
    },
    listAdminSignatureAttest: {
        name: "list_admin_signature_attest",
        label: "",
        required: false,
    },
    listAdminSignatureText: {
        name: "list_admin_signature_text",
        label: "Broker Signature",
        required: false,
    },
    listAdminSignatureDate: {
        name: "list_admin_signature_date",
        label: "Broker Signed Date",
        required: false,
    },
    listOwnerSignatureAttest: {
        name: "list_owner_signature_attest",
        label: "List Owner Signature Attest",
        required: false,
    },
    listOwnerSignatureText: {
        name: "list_owner_signature_text",
        label: "List Owner Signature",
        required: false,
    },
    listOwnerSignatureDate: {
        name: "list_owner_signature_date",
        label: "List Owner Signed Date",
        required: false,
    },
}

export const pafApplicationFields = {
    pafId: {
        name: "paf_id",
        label: "PAF Id",
        required: false,
    },
    pafSid: {
        name: "paf_sid",
        label: "Company SID",
        required: false,
    },
    isForeignLocation: {
        name: "is_foreign_location",
        label: "Foreign Location",
        required: true,
    },
    isNcoa: {
        name: "is_ncoa",
        label: "NCOALink Service",
        required: true,
    },
    isDsf: {
        name: "is_dsf",
        label: "DSF2 Service",
        required: true,
    },
    isTriplex: {
        name: "is_triplex",
        label: "Triplex",
        required: true,
    },
    isWaiverOnFile: {
        name: "is_waiver_on_file",
        label: "NCOALink 7-Day Fulfillment Waiver on File",
        required: true,
    },
    listName: {
        name: "list_name",
        label: "List Name",
        required: false,
    },
    comments: {
        name: "comments",
        label: "Comments",
        required: false,
    },
    notes: {
        name: "notes",
        label: "Notes",
        required: false,
    },
    customerSignedDatetime: {
        name: "list_owner_signature_date",
        label: "Customer Signed Date",
        required: false,
    },
    brokerSignedDatetime: {
        name: "list_admin_signature_date",
        label: "List Admin Signed Date",
        required: false,
    },
    licenseeSignedDatetime: {
        name: "licensee_signature_date",
        label: "Licensee Signed Date",
        required: false,
    },
    frequency: {
        name: "frequency",
        label: "Frequency",
        required: false,
    },
    status: {
        name: "status",
        label: "Status",
        required: false,
    },
    signatureStatus: {
        name: "signature_status",
        label: "signature_status",
        required: false,
    },
    isDeleted: {
        name: "is_deleted",
        label: "Is Deleted",
        required: true,
    },
    expirationDate: {
        name: "expiration_date",
        label: "Expiration Date",
        required: false,
    },
    createDatetime: {
        name: "create_datetime",
        label: "Created at",
        required: false,
    },
    modifyDatetime: {
        name: "modify_datetime",
        label: "Modified at",
        required: false,
    },
    modifyUserName: {
        name: "modify_user_name",
        label: "Modified By",
        required: false,
    },
    customerId: {
        name: "customer_id",
        label: "Customer Id",
        required: true,
    },
    companyName: {
        name: "company__company_name",
        label: "Company Name",
        required: true,
    },
    parentCompanyName: {
        name: "company__parent_company_name",
        label: "Parent Company Name",
        required: false,
    },
    dbaName: {
        name: "company__dba_name",
        label: "DBA Name",
        required: false,
    },
    address1: {
        name: "company__address1",
        label: "Address 1",
        required: true,
    },
    address2: {
        name: "company__address2",
        label: "Address 2",
        required: false,
    },
    city: {
        name: "company__city",
        label: "City",
        required: true,
    },
    state: {
        name: "company__state",
        label: "State",
        required: true,
    },
    postalCode: {
        name: "company__postal_code",
        label: "Zip",
        required: true,
    },
    urbanization: {
        name: "company__urbanization",
        label: "Urbanization",
        required: false,
    },
    federalTaxId: {
        name: "company__federal_tax_id",
        label: "Federal Tax Id",
        required: false,
    },
    naicsCode: {
        name: "company__naics_code",
        label: "NAICS Code",
        required: true,
    },
    uspsMailerId: {
        name: "company__usps_mailer_id",
        label: "USPS Mailer Id",
        required: false,
    },
    customerRegistrationId: {
        name: "company__company_registration_id",
        label: "CR ID",
        required: false,
    },
    representativeName: {
        name: "company__representative_name",
        label: "Representative Name",
        required: true,
    },
    representativeTitle: {
        name: "company__representative_title",
        label: "Representative Title",
        required: false,
    },
    representativeEmail: {
        name: "company__representative_email",
        label: "Representative Email",
        required: true,
    },
    companyWebsite: {
        name: "company__company_website",
        label: "Company Website",
        required: false,
    },
    phone: {
        name: "company__phone",
        label: "Telephone",
        required: true,
    },
    customerSinceDate: {
        name: "company__customer_since_date",
        label: "Customer Since Date",
        required: true,
    },
    customerIsDeleted: {
        name: "company__is_deleted",
        label: "Is Deleted",
        required: true,
    },
    customerIsInternal: {
        name: "company__is_internal",
        label: "Is Internal",
        required: true,
    },
    listAdminId: {
        name: "listadmin_id",
        label: "ListAdmin Id",
        required: false,
    },
    listAdminSid: {
        name: "listadmin__listadmin_sid",
        label: "List Admin SID",
        required: false,
    },
    listAdminCompanyName: {
        name: "listadmin__company_name",
        label: "Company Name",
        required: false,
    },
    listAdminAddress1: {
        name: "listadmin__address1",
        label: "Address 1",
        required: false,
    },
    listAdminAddress2: {
        name: "listadmin__address2",
        label: "Address 2",
        required: false,
    },
    listAdminCity: {
        name: "listadmin__city",
        label: "City",
        required: false,
    },
    listAdminState: {
        name: "listadmin__state",
        label: "State",
        required: false,
    },
    listAdminPostalCode: {
        name: "listadmin__postal_code",
        label: "Zip",
        required: false,
    },
    listAdminRepresentativeName: {
        name: "listadmin__representative_name",
        label: "Representative Name",
        required: false,
    },
    listAdminRepresentativeTitle: {
        name: "listadmin__representative_title",
        label: "Representative Title",
        required: false,
    },
    listAdminRepresentativeEmail: {
        name: "listadmin__representative_email",
        label: "Representative Email",
        required: false,
    },
    listAdminPhone: {
        name: "listadmin.phone",
        label: "Phone",
        required: false,
    },
    listAdminFederalTaxId: {
        name: "listadmin__federal_tax_id",
        label: "Fedreal Tax Id",
        required: false,
    },
    listAdminNaicsCode: {
        name: "listadmin__naics_code",
        label: "NAICS",
        required: false,
    },
    licenseeId: {
        name: "licensee_id",
        label: "Licensee Id",
        required: false,
    },
    licenseeAcctExec: {
        name: "licensee_acct_exec",
        label: "Account Exec",
        required: true,
    },
    licenseeSalesOffice: {
        name: "licensee_sales_office",
        label: "Sales Office",
        required: false,
    },
    licenseeOperator: {
        name: "licensee_operator",
        label: "Operator",
        required: true,
    },
    licenseeCompanyName: {
        name: "licensee__company_name",
        label: "Company Name",
        required: false,
    },
    licenseeOfficerName: {
        name: "licensee__officer_name",
        label: "Officer Name",
        required: false,
    },
    licenseeOfficerTitle: {
        name: "licensee__officer_title",
        label: "Officer Title",
        required: false,
    },
    licenseePhone: {
        name: "licensee__phone",
        label: "Phone",
        required: false,
    },
    licenseeFax: {
        name: "licensee__fax",
        label: "Fax",
        required: false,
    },
    licenseeFederalTaxId: {
        name: "licensee__federal_tax_id",
        label: "Federal Tax Id",
        required: false,
    },
    licenseeSignatureAttest: {
        name: "licensee_signature_attest",
        label: "",
        required: false,
    },
    licenseeSignatureText: {
        name: "licensee_signature_text",
        label: "Signature",
        required: false,
    },
    licenseeSignatureDate: {
        name: "licensee_signature_date",
        label: "Signed Date",
        required: false,
    },
    listAdminSignatureAttest: {
        name: "list_admin_signature_attest",
        label: "",
        required: false,
    },
    listAdminSignatureText: {
        name: "listadmin_signature_text",
        label: "Signature",
        required: false,
    },
    listAdminSignatureDate: {
        name: "listadmin_signature_date",
        label: "Signed Date",
        required: false,
    },
    listOwnerSignatureAttest: {
        name: "list_owner_signature_attest",
        label: "Signature Attest",
        required: false,
    },
    listOwnerSignatureText: {
        name: "listowner_signature_text",
        label: "Signature",
        required: false,
    },
    listOwnerSignatureDate: {
        name: "listowner_signature_date",
        label: "Signed Date",
        required: false,
    },
}

export const pafApplicationSignatureFields = {
    isAttest: {
        name: "is_attest",
        label: "I attest that I have read and understand the terms of use",
        required: true,
    },
    signature_text: {
        name: "signature_text",
        label: "Signature",
        required: true,
    },
    signedDate: {
        name: "signed_date",
        label: "Signed Date",
        required: false,
    },
}




